<template>
  <div>
    <el-dialog :visible.sync="isShow" title="修改接口地址" width="800px"
      :close-on-click-modal="false" :close-on-press-escape="false" :destroy-on-close="true" @close="close">
      <div class="title-style" slot="title">
        <div class="dialog_title">修改接口地址</div>
        <div class="bd_bottom"></div>
      </div>
      <el-form ref="form" :model="formData" :rules="formRules" label-width="80px" label-position="top">
        <el-form-item label="填写用于接收消息的URL" prop="url">
          <el-input v-model="formData.url"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="edit">完 成</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'EditUrl',
  data() {
    return {
      isShow: false,
      formData: { url: '' },
      formRules: {
        url: [
          { required: true, message: '请输入接口地址', trigger: 'blur' }
        ]
      },
      index: null
    }
  },
  methods: {
    init(info) {
      const { url, index } = JSON.parse(JSON.stringify(info));
      this.index = index
      this.formData.url = url
      this.isShow = true
    },
    close() {
      this.formData = { url: '' }
      this.index = null
      this.isShow = false
    },
    async edit() {
      const vali = await this.$refs.form.validate()
      if (vali) {
        this.$emit('editApiUrl', { url: this.formData.url, index: this.index })
        this.close()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.title-style {
  .dialog_title {
    padding: 20px 0 17px 40px;
    font-size: 20px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 700;
    text-align: left;
    color: #2b2b2b;
  }
  .bd_bottom {
    height: 1px;
    background: #d9d9d9;
    border-radius: 6px;
  }
}
::v-deep .el-input__inner {
  border-radius: 6px !important;
}
::v-deep .el-dialog__header {
  padding: 0 !important;
}
::v-deep .el-dialog__footer {
  text-align: center;
}
::v-deep .el-dialog {
  border-radius: 6px;
}
</style>
